<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>培训分类使用说明:<br>
					<span>1、如果使用了,只能注销。否则可以直接删除。如果要计算具体费用类型,需要配合 关键字才能生效</span><br>
					
				</h5>
			</div>
		</div>
		<!-- 主+明细 -->
		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			<!-- <template slot="slot_c_out_fee">
        <pre-select class="short0" ref="out_fee" @selectFunc="selectFunc1" v-bind:searchList="list_fee"
          :selectValue="sel_fee" />
      </template> -->
		</pre-base>

	</div>
</template>

<script>
	// import {
	// 	GetShort
	// } from '@/utils/localstore.js';

	export default {
		components: {
			"pre-base": () => import("../auto/auto_view_easy.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',

				// 组件
				show_tan: '0',
				show_item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				// let udata = GetShort('userdata');
				// let rname = '';
				// if (typeof(udata) !== 'undefined' && udata != '') {
				// 	let r = JSON.parse(udata);
				// 	rname = r[0].rname;
				// }
				// console.log('当前角色:' + rname);
				this.init_data = '';

				this.init_data = JSON.stringify({
					"control": "px_class",
					"title": "培训分类",
					"isTwo": "0",
					"isTwoDetail": "0",
					"action_flag": "",
					"isFileMain": "1",
					"step": "0",
					"sel_action": 'exp_px_study_class',
					"upd_action": 'exp15_px_study_class',
					"detail_part": "0",
					"detail_excelup": "0",
					"d_btn_more": "0",
					"d_sel_action": '',
					"d_upd_action": '',
					"file_action": '',
					"p1": '',
					"p2": '',
					"p3": '',						
					"parm": [
						{
							"name": "名称",
							"val": "",
							"key": "name",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						
					],
					"parm_th": [
						{
							"name": "序号"
						}, 
						{
							"name": "名称"
						},
						{
							"name": "备注"
						},
						{
							"name": "状态"
						},
						{
							"name": "修改人"
						},
						{
							"name": "修改时间"
						}
					],
					"d_parm": [
					],
					"d_name": [
					]
				
				});

			},
			refresh_data: function() {
				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data('1');
				});
			},
			refresh_father: function(type, val, parm) {
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						// this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			}



		}
	};
</script>
<style>
</style>
